module.exports = __webpack_public_path__ + "img/dog_half.5d3357e4.svg";